export default __webpack_public_path__ + "static/media/2021-Estados-Financieros-31.03.2021.8c0a17f9.webp";